var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NoteStreamReceiver_instances, _NoteStreamReceiver_terminator, _NoteStreamReceiver_bits, _NoteStreamReceiver_notifier, _NoteStreamReceiver_binding, _NoteStreamReceiver_subscribe;
import { Bits, Notifier, Terminable, Terminator } from "@opendaw/lib-std";
export class NoteStreamReceiver {
    constructor(receiver, address) {
        _NoteStreamReceiver_instances.add(this);
        _NoteStreamReceiver_terminator.set(this, new Terminator());
        _NoteStreamReceiver_bits.set(this, void 0);
        _NoteStreamReceiver_notifier.set(this, void 0);
        _NoteStreamReceiver_binding.set(this, Terminable.Empty);
        __classPrivateFieldSet(this, _NoteStreamReceiver_bits, new Bits(128), "f");
        __classPrivateFieldSet(this, _NoteStreamReceiver_notifier, new Notifier(), "f");
        if (address !== undefined) {
            __classPrivateFieldSet(this, _NoteStreamReceiver_binding, __classPrivateFieldGet(this, _NoteStreamReceiver_instances, "m", _NoteStreamReceiver_subscribe).call(this, receiver, address), "f");
        }
    }
    bind(receiver, address) {
        __classPrivateFieldGet(this, _NoteStreamReceiver_binding, "f").terminate();
        __classPrivateFieldGet(this, _NoteStreamReceiver_bits, "f").clear();
        __classPrivateFieldSet(this, _NoteStreamReceiver_binding, __classPrivateFieldGet(this, _NoteStreamReceiver_instances, "m", _NoteStreamReceiver_subscribe).call(this, receiver, address), "f");
        __classPrivateFieldGet(this, _NoteStreamReceiver_notifier, "f").notify(this);
        return __classPrivateFieldGet(this, _NoteStreamReceiver_binding, "f");
    }
    isNoteOn(note) { return __classPrivateFieldGet(this, _NoteStreamReceiver_bits, "f").getBit(note); }
    isAnyNoteOn() { return __classPrivateFieldGet(this, _NoteStreamReceiver_bits, "f").nonEmpty(); }
    subscribe(observer) { return __classPrivateFieldGet(this, _NoteStreamReceiver_notifier, "f").subscribe(observer); }
    terminate() {
        __classPrivateFieldGet(this, _NoteStreamReceiver_binding, "f").terminate();
        __classPrivateFieldGet(this, _NoteStreamReceiver_terminator, "f").terminate();
    }
}
_NoteStreamReceiver_terminator = new WeakMap(), _NoteStreamReceiver_bits = new WeakMap(), _NoteStreamReceiver_notifier = new WeakMap(), _NoteStreamReceiver_binding = new WeakMap(), _NoteStreamReceiver_instances = new WeakSet(), _NoteStreamReceiver_subscribe = function _NoteStreamReceiver_subscribe(receiver, address) {
    return receiver.subscribeIntegers(address, (array) => {
        if (__classPrivateFieldGet(this, _NoteStreamReceiver_bits, "f").replace(array.buffer)) {
            __classPrivateFieldGet(this, _NoteStreamReceiver_notifier, "f").notify(this);
        }
    });
};
